module.exports = __webpack_public_path__ + "static/media/Booking-Details.f6463aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/booking/Booking-Details.png
// module id = 97
// module chunks = 0